import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=b9d36dce&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9d36dce')) {
      api.createRecord('b9d36dce', component.options)
    } else {
      api.reload('b9d36dce', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=b9d36dce&", function () {
      api.rerender('b9d36dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27y3kBoSJZE1T/JS/comp/DateRangeExt.vue"
export default component.exports